module.exports = __webpack_public_path__ + "img/5x-block.43998c9.png";